import g1 from './girlspfp/g1.png';
import g2 from './girlspfp/g2.png';
import g3 from './girlspfp/g3.png';
import g4 from './girlspfp/g4.png';
import g5 from './girlspfp/g5.png';
import g6 from './girlspfp/g6.png';
import g7 from './girlspfp/g7.png';
import g8 from './girlspfp/g8.png';
function Girlspfp(props:any){
let itemimg = g1;
let iwth = props.wth;
let iht = props.hgt;
//alert(props.itp);
if(props.itemid == 1) itemimg = g1;
else if(props.itemid == 2) itemimg = g2;
else if(props.itemid == 3) itemimg = g3;
else if(props.itemid == 4) itemimg = g4;
else if(props.itemid == 5) itemimg = g5;
else if(props.itemid == 6) itemimg = g6;
else if(props.itemid == 7) itemimg = g7;
else if(props.itemid == 8) itemimg = g8;

//alert(props.itemid);
return(
<div className="per100">
	<div>
        
	<img style={{width:iwth,height:iht}} src={itemimg} className="c-pfp-img" />

	</div>		
		
 </div>
);
}
export default Girlspfp;
